<script setup lang="ts">
import type { IconConstant } from '@tpg/grammar-web-icons';
import type { Slot } from 'vue';

export interface GrammarOverlayCardProps {
  fillTrailingHeader?: boolean;
  leadingIconTemplate?: IconConstant | '';
  headingLabel?: string;
  label?: string;
  borderType?: 'ok' | 'accent' | 'error' | 'warning' | 'danger' | '';
}

export interface GrammarOverlayCardSlots {
  'header-leading-buttons'?: Slot;
  'header-trailing-buttons'?: Slot;
  'header-generic'?: Slot;
  'default'?: Slot;
  'footer'?: Slot;
}

const props = withDefaults(defineProps<GrammarOverlayCardProps>(), {
  fillTrailingHeader: false,
  leadingIconTemplate: '',
  headingLabel: '',
  label: '',
  borderType: '',
});

const slots = defineSlots<GrammarOverlayCardSlots>();
</script>

<template>
  <tpg-overlay-card
    v-bind="props"
  >
    <div
      v-if="slots['header-leading-buttons']"
      slot="header-leading-buttons"
    >
      <slot name="header-leading-buttons" />
    </div>

    <div
      v-if="slots['header-trailing-buttons']"
      slot="header-trailing-buttons"
    >
      <slot name="header-trailing-buttons" />
    </div>

    <div v-if="slots['header-generic']" slot="header-generic">
      <slot name="header-generic" />
    </div>

    <slot />

    <div v-if="slots.footer" slot="footer">
      <slot name="footer" />
    </div>
  </tpg-overlay-card>
</template>
